module.exports = __webpack_public_path__ + "img/1083.82aa4632.gif";